import { render, staticRenderFns } from "./TemplateProperties.vue?vue&type=template&id=af850820"
import script from "./TemplateProperties.vue?vue&type=script&lang=js"
export * from "./TemplateProperties.vue?vue&type=script&lang=js"
import style0 from "./TemplateProperties.vue?vue&type=style&index=0&id=af850820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports